export default [
    {
        name: 'Etapas',
        url: '/sgtec/financeiro/etapas',
        icon: 'fa fa-tasks',
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        },
        regras: 'SGTEC-UFI-ETP-00'
    },
    {
        name: 'Pagamentos',
        url: '/sgtec/financeiro/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        },
        regras: 'SGTEC-UFI-PAG-00'
    }
]
